import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { ScrollToTop } from './components/ScrollToTop'
import { Header } from './components/Header'
import { Footer } from './components/Footer'
import { FloatingCTA } from './components/FloatingCTA'

// Pages
import { HomePage } from './pages/HomePage'
import { KropsterapiPage } from './pages/KropsterapiPage'
import { CoachingPage } from './pages/CoachingPage'
import { HypnoterapiPage } from './pages/HypnoterapiPage'
import { ForloebPage } from './pages/ForloebPage'
import { OmBoPage } from './pages/OmBoPage'
import { GrundprincipperPage } from './pages/GrundprincipperPage'
import { KlienthistoriePage } from './pages/KlienthistoriePage'
import { UddannelsePage } from './pages/UddannelsePage'
import { VideoPage } from './pages/VideoPage'
import { KontaktPage } from './pages/KontaktPage'
import { AfbudspolitikPage } from './pages/AfbudspolitikPage'
import { HandelsbetingelserPage } from './pages/HandelsbetingelserPage'
import { AlignFootwearPage } from './pages/AlignFootwearPage'
import { NotFoundPage } from './pages/NotFoundPage'
import { ForbiddenPage } from './pages/ForbiddenPage'

export default function App() {
  return (
    <div className="min-h-screen flex flex-col bg-[#FAF8F5] text-[#1E293B]">
      <ScrollToTop />
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/kropsterapi" element={<KropsterapiPage />} />
          <Route path="/coaching" element={<CoachingPage />} />
          <Route path="/hypnoterapi" element={<HypnoterapiPage />} />
          <Route path="/forloeb" element={<ForloebPage />} />
          <Route path="/om-bo" element={<OmBoPage />} />
          <Route path="/om-Bo_og_Ellen" element={<OmBoPage />} />
          <Route path="/mine-9-grundprincipper" element={<GrundprincipperPage />} />
          <Route path="/klienthistorie" element={<KlienthistoriePage />} />
          <Route path="/KlientHistorie" element={<KlienthistoriePage />} />
          <Route path="/uddannelse" element={<UddannelsePage />} />
          <Route path="/video" element={<VideoPage />} />
          <Route path="/kontakt" element={<KontaktPage />} />
          <Route path="/afbudspolitik" element={<AfbudspolitikPage />} />
          <Route path="/handelsbetingelser" element={<HandelsbetingelserPage />} />
          <Route path="/align-footwear-ny" element={<AlignFootwearPage />} />
          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  )
}
